import {observer} from "mobx-react"
import {useState} from "react"
import {DialogStore, growlStore, userDetailStore} from "../../../store"
import {ModalDialog, Page, PageContentTitle} from "../../ui"
import {UserForm} from "./UserForm"

const UserDetailPage = observer(function UserDetailPage() {
    const [cancelDialog] = useState(new DialogStore())
    const fullName = `${userDetailStore.original?.firstname} ${userDetailStore.original?.lastname}`

    return <Page cssSuffix={"user"}
                 breadcrumb={[
                     {
                         link: `/ums/user`,
                         label: 'Benutzer'
                     },
                     {
                         link: '#',
                         label: fullName
                     }
                 ]}
    >
        <ModalDialog
            store={cancelDialog}
            actions={[
                {
                    label: "Abbrechen",
                    execute: async function () {
                        cancelDialog.dialogOpen = false
                    },
                    className: 'is-primary is-rounded is-small'
                },
                {
                    label: "Verwerfen",
                    execute: async function () {
                        userDetailStore.reset()
                        cancelDialog.dialogOpen = false
                    },
                    className: 'is-rounded is-small'
                }
            ]}
            title={"Änderungen verwerfen?"}
        >
            Sind Sie sich sicher, dass Sie die Änderungen verwerfen wollen?
        </ModalDialog>
        <PageContentTitle
            actions={[
                {
                    label: 'Speichern',
                    cls: `is-primary ${userDetailStore.saving ? 'is-loading' : ''}`,
                    disabled: !userDetailStore.valid || !userDetailStore.dirty,
                    action: async () => {
                        const response = await userDetailStore.save()
                        if (!response) {
                            return
                        }
                        userDetailStore.reset()
                        growlStore.add({
                            message: 'Änderungen erfolgreich gespeichert',
                            autoclose: true,
                            closable: true
                        })
                    }
                },
                {
                    label: 'Verwerfen',
                    cls: 'is-primary is-outlined',
                    disabled: userDetailStore.saving,
                    action: () => {
                        cancelDialog.dialogOpen = true
                    }
                },
            ]}
        >{fullName} bearbeiten</PageContentTitle>
        <UserForm
            saving={userDetailStore.saving}
            data={userDetailStore.formData}
            visibleUsername={true}
            visibleKeycloakId={true}
            onValidate={() => userDetailStore.validate().finally()}
            onChange={v => {
                userDetailStore.formData = v
            }}
        />
    </Page>
})

export {
    UserDetailPage
}
